import WebStorageService from '_services/webstorage.service'
import WebStorageKey from 'enums/web-storage-key.enum'
const parse = require('url-parse')

const apiServers = {
  local: '//localhost:3000',
  development: '//api-${USER}.staging.meinbuero.de', // eslint-disable-line
  test: '//api-test.meinbuero.de',
  prelive: '//api-prelive.meinbuero.de',
  production: 'https://api.meinbuero.de',
}

const defaultApmConfig = {
  flushInterval: 5000,
  active: true,
  // only errors
  disableInstrumentations: ['eventtarget', 'click', 'page-load', 'history', 'fetch', 'xmlhttprequest'],
}

const apmServerConfig = {
  local: {
    serviceName: 'meinbuero-local-web',
    ...defaultApmConfig,
    // everything
    disableInstrumentations: [],
    // logLevel: 'debug',
  },
  development: {
    serviceName: 'meinbuero-${USER}-web',  // eslint-disable-line
    ...defaultApmConfig,
    // errors and requests
    disableInstrumentations: ['eventtarget', 'click', 'page-load', 'history'],
  },
  test: {
    serviceName: 'meinbuero-test-web',
    ...defaultApmConfig,
  },
  prelive: {
    serviceName: 'meinbuero-prelive-web',
    ...defaultApmConfig,
  },
  production: {
    serviceName: 'meinbuero-prod-web',
    ...defaultApmConfig,
    active: false,
  },
}

const customerCenterServers = {
  local: '//localhost:3001',
  development: '//ext-${USER}.meinbuero.de', // eslint-disable-line
  test: '//external-test.meinbuero.de',
  prelive: '//external-prelive.meinbuero.de',
  production: 'https://external.meinbuero.de',
}

export const apiRoot = WebStorageService.getItem(WebStorageKey.API_ROOT) || apiServers[ENV.build]
export const apmConfig = apmServerConfig[ENV.build]
export const apiRootHost = parse(apiRoot).host
export const customerCenterRoot = customerCenterServers[ENV.build]

const getResourceHost = () => {
  return `${apiRoot}/api/`
}

const getAssetResourceHost = () => {
  return `${apiRoot}/api`
}

export const externalHost = customerCenterRoot
export const resourceHost = getResourceHost()
// TODO: use mainly assetResourceHost
export const imageResourceHost = getAssetResourceHost()
export const assetResourceHost = getAssetResourceHost()

const config = {
  apiRoot,
  externalHost,

  // resource endpoints
  resourceHost,
  imageResourceHost,
  assetResourceHost,
}

export default config
